import { ArgsType } from '@nestjs/graphql'
import { BaseAddPictureDto } from '../base/baseAddPicture.dto'

@ArgsType()
export class ArcTeamAddPictureDto extends BaseAddPictureDto { }
